<template>
  <div class="callme">
    <div v-show="!isTips" style="width: 685px;margin: 0 auto;">
        <div class="callme-title">{{$t('common_conj_contact')}}</div>
        <div>
          <img src="../assets/b2.png" alt="b2" />
          <div class="callme-box_title">
            <span>{{$t('feedBack_专人在线演示解答')}}</span>
            <span>{{$t('feedBack_快速了解产品功能使用')}}</span>
            <span>{{$t('feedBack_提供专属解决方案')}}</span>
          </div>
        </div>
        <div class="describe"></div>
        <!-- <div class="describe">请留下您的有效联系方式，我们的业务专家会及时联系您，与您确定业务交流和系统演示的时间，祝您事业蒸蒸日上！</div> -->
        <a-row class="form-item" type="flex">
          <a-col class="form-item__label">
            <span class="gb-must-write">{{$t('common_form_real_name')}}：</span>
          </a-col>
          <a-input :placeholder="$t('childAct_输入姓名')" :disabled="!!info.realName" class="login-input" v-model="adviceName" />
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{$t('common_menu_my_doc_fankui')}}</span>
            </template>
            <span class="icon-wenti info-icon"></span>
          </a-tooltip>
        </a-row>

        <a-row class="form-item" :span="24" type="flex">
          <a-col class="form-item__label">
            <span class="gb-must-write">{{$t('common_conj_mobile', [])}}：</span>
          </a-col>
          <a-col>
            <a-input
              :placeholder="$t('feedBack_请输入电话号码')"
              class="login-input"
              @keyup="advicePhone = advicePhone.replace(/[^\d]/g, '')"
              :maxLength="Number(num)"
              v-model="advicePhone"
              :disabled="!!info.phone"
            />
          </a-col>
        </a-row>

        <a-row class="form-item" :span="24" type="flex">
          <a-col class="form-item__label">
            <span class="gb-must-write">{{$t('common_form_email')}}：</span>
          </a-col>
          <a-col>
            <a-input :placeholder="$t('childAct_请输入邮箱')" class="login-input" :disabled="!!info.email" v-model="email" />
          </a-col>
        </a-row>

        <a-row class="form-item" :span="24" type="flex">
          <a-col class="form-item__label">
            <span class="gb-must-write">{{$t('common_form_comp_name')}}：</span>
          </a-col>
          <a-col>
            <a-input :placeholder="$t('feedBack_请输入公司名称')" class="login-input" v-model="companyName" />
          </a-col>
        </a-row>

        <a-row class="form-item" :span="24" type="flex">
          <a-col class="form-item__label">
            <span class="gb-must-write">{{$t('feedBack_公司区域')}}：</span>
          </a-col>
          <a-col>
            <!-- <a-input placeholder="请输入公司所在地" class="login-input" v-model="companyAddress" /> -->
            <a-cascader
              v-model="addressCode"
              class="login-input cascader"
              style="background-color: transparent; font-size: 14px;"
              popupPlacement="topLeft"
              :options="cascaderOptions"
              :load-data="loadData"
              :placeholder="$t('common_globalcomp_select_area')"
              change-on-select
              @change="onChangeCascader"
            >
            </a-cascader>
          </a-col>
        </a-row>

        <!-- <a-row class="form-item" :span="24" type="flex">
          <a-col class="form-item__label">
            <span class="gb-must-write">产品需求：</span>
          </a-col>
          <a-col>
            <a-input placeholder="请输入公司所在地" class="login-input" v-model="adviceWechat" />
          </a-col>
        </a-row> -->

        <a-row class="form-item" :span="24" type="flex">
          <a-col class="form-item__label">
            <span class="gb-must-write">{{$t('common_form_select_pro_req')}}：</span>
          </a-col>
          <a-col>
            <a-select v-model="productCode" allow-clear :placeholder="$t('common_form_select_pro_req')" class="form-input-width">
              <a-select-option :value="item" v-for="(item,index) in optionsVal" :key="index">
                {{item}}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>

        <a-row class="form-item" :span="24" type="flex">
          <a-col class="form-item__label">
            <span>{{$t('common_form_remark')}}：</span>
          </a-col>
          <a-col>
            <a-textarea
              v-model="remark"
              style="width:486px;"
              :placeholder="$t('feedBack_选填，其他内容可在备注中')"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </a-col>
        </a-row>
        <!-- <div><a-input placeholder="请输入微信号" class="login-input" style="" v-model="adviceWechat" /></div> -->
        <a-config-provider :auto-insert-space-in-button="false">
            <a-button class="login-btn" @click="handleSubmit" type="primary">
                {{$t('feedBack_预约')}}
            </a-button>
        </a-config-provider>
    </div>
    <div v-show="isTips" class="seccess-box">
        <img class="callme-avatar" src="../assets/o1.png" alt="b1" />
        <div class="callme-secces">{{$t('common_menu_Successful_appointment')}}</div>
        <div class="callme-take">{{$t('feedBack_业务专家将会尽快联系您')}}</div>
        <router-link to="/" tag="div" class="callme-backhome">{{$t('common_btn_back_home')}}</router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { openNotificationWithIcon } from '@/utils/util'
import { SsoGetCityInfo, GetEosBaseInfo, ReservationShow, GetPersonalUserSub } from '@/api/login'
import { mapState, mapMutations } from 'vuex'
import { Cascader } from 'ant-design-vue'

export default {
  name: 'callme',
  data () {
    return {
      num: 11,
      isTips: false,
      adviceName: '',
      advicePhone: '',
      companyName: '',
      companyAddress: '',
      adviceWechat: '',
      cascaderOptions: [],
      addressCode: [],
      remark: '',
      email: '',
      info: {},
      productCode: undefined, // 产品
      optionsVal: [] // 产品下拉框
    }
  },
  components: {
    ACascader: Cascader
  },
  computed: {
    ...mapState({
      hideInfo: state => state.isLogin.hideInfo
    })
  },
  mounted () {
    this.GetEosBaseInfo()
    this._SsoGetCityInfo({ cityScope: 'province' })
    GetPersonalUserSub({}).then(({ data }) => {
      const { realName, email, phone } = data
      this.info = data
      this.adviceName = realName
      this.advicePhone = phone
      this.email = email
      this.companyName = this.hideInfo.onlineSubjectName
    })
    this.IS_CALLME(false)
  },
  methods: {
    ...mapMutations(['IS_CALLME']),
    handleSubmit () {
      const {
        adviceName,
        advicePhone,
        companyName,
        addressCode,
        productCode,
        email,
        remark
      } = this
      if (!adviceName) {
        return openNotificationWithIcon(this.$t('feedBack_姓名不能为空'))
      }
      if (!advicePhone) {
        return openNotificationWithIcon(this.$t('feedBack_电话不能为空'))
      }
      if (!email) {
        return openNotificationWithIcon(this.$t('feedBack_邮箱不能为空'))
      }
      if (addressCode.length === 0) {
        return openNotificationWithIcon(this.$t('feedBack_区域不能为空'))
      }
      if (!companyName) {
        return openNotificationWithIcon(this.$t('feedBack_公司不能为空'))
      }
      if (!productCode) return openNotificationWithIcon(this.$t('common_login_ckeck_产品需求不能为空'))

      // if (this.companyAddress === '') {
      //   return openNotificationWithIcon('公司所在地不能为空')
      // }
      // if (this.adviceWechat === '') {
      //   return openNotificationWithIcon('微信号不能为空')
      // }
      // let data = {
      //   adviceName: this.adviceName,
      //   advicePhone: this.advicePhone,
      //   companyName: this.companyName,
      //   companyAddress: this.companyAddress,
      //   adviceWechat: this.adviceWechat
      // }
      const params = {
        mobile: advicePhone.trim(), // 手机号
        email: email.trim(), // 邮箱
        name: adviceName, // 姓名
        companyName, // 公司名称
        remark, // 备注
        categoryName: productCode, // 产品
        provinceCode: addressCode[0], // 省
        cityCode: addressCode[1], // 市
        areaCode: addressCode[2] // 区
      }
      ReservationShow(params).then((res) => {
        const { message } = res
        if (res.code === '200') {
          this.isTips = true
          // $store.dispatch('setMenus', data)
        } else {
          openNotificationWithIcon(message)
        }
      })
    },
    // 产品下拉框数据
    GetEosBaseInfo () {
      GetEosBaseInfo().then(({ data }) => {
        this.optionsVal = new Set(data.categoryName)
      })
    },
    onChangeCascader (value) {
      if (value && value.length) {
        this.addressCode = value
      } else {
        this.addressCode = []
      }
    },
    loadData (selectedOptions) {
      const len = selectedOptions.length
      const targetOption = selectedOptions[len - 1]
      targetOption.loading = true

      const params = {
        cityScope: len > 1 ? 'area' : 'city',
        cityCode: targetOption.value
      }
      SsoGetCityInfo(params).then(res => {
        const { data } = res
        targetOption.loading = false
        let children = []
        if (data && data.length) {
          data.forEach(item => {
            let itemOpt = {
              value: item.cityCode,
              label: item.cityName
            }
            if (len === 1) itemOpt.isLeaf = false
            children.push(itemOpt)
          })
          targetOption.children = children
        }
        this.cascaderOptions = [...this.cascaderOptions]
      })
    },
    getCityFn (type, code) {
      return new Promise((resolve, reject) => {
        const params = {
          cityScope: type, // 'area' : 'city',
          cityCode: code
        }
        SsoGetCityInfo(params).then(res => {
          const { data } = res
          let children = []
          if (data && data.length) {
            data.forEach(item => {
              let itemOpt = {
                value: item.cityCode,
                label: item.cityName
              }
              if (type === 'city') itemOpt.isLeaf = false
              children.push(itemOpt)
            })
          }
          resolve(children)
        })
      })
    },
    _SsoGetCityInfo (params) {
      SsoGetCityInfo(params).then(res => {
        const { data } = res
        let optionAry = []
        this.cascaderOptions = []
        if (data && data.length) {
          data.forEach(item => {
            const itemOpt = {
              value: item.cityCode,
              label: item.cityName,
              isLeaf: false
            }
            optionAry.push(itemOpt)
          })
          this.cascaderOptions = optionAry
        }
      })
    },
    onChange (date, dateString) {
      // console.log(date, dateString)
    }
  }
}
</script>
<style lang="less" scoped>
.callme {
  text-align: center;
  background-color: #fff;
  min-height: 904px;
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px;
  padding-left: 24px;
  margin-bottom: 32px;
  .callme-title {
    padding-top: 76px;
    margin-bottom: 32px;
    font-weight:600;
    color:#333333;
    font-size:24px;
  }
  .callme-box_title {
    display: flex;
    justify-content: space-around;
    padding: 0 89px;
    padding-left: 99px;
  }
  .describe {
    width:485px;
    margin: 0 auto;
    font-size:14px;
    // margin-top: 32px;
    text-align: left;
    margin-bottom: 32px;
  }
}

.form-item {
  margin-top: 14px;
  &__label {
    text-align: right;
    padding-right: 10px;
    line-height: 32px;
    width: 145px;
    position: relative;
    .gb-must-write {
      position: absolute;
      right: 0;
      height: 44px;
      line-height: 44px;
      white-space: nowrap;
    }
  }
}
/deep/ .ant-select-arrow-icon {
  font-size: 13px;
}
.flex1 {
  flex: 1;
}
.form-input-width {
  width: 486px;
}
/deep/ .ant-select-selection--single {
  height: 44px;
}
/deep/ .ant-select-selection--single .ant-select-selection__rendered {
  line-height: 44px;
}
.form-item__label {
  text-align: right;
  padding-right: 0px;
  line-height: 32px;
  width: 145px;
  position: relative;
}
.info-icon {
  margin-left: 10px;
  cursor: pointer;
  font-size: 20px;
  color: #80b3ff;
  line-height: 40px;
  &:hover {
    color: rgba(128, 179, 255, .8);
  }
}
.cascader {
  text-align:left;
  /deep/ .ant-cascader-input.ant-input {
    height: 48px;
    line-height: 48px;
  }
}
.color-upoload {
  color: #4978D6;
}
.seccess-box {
  padding-top: 134px;
}
.login-input {
  width:485px;
  height:44px;
  // margin-bottom: 14px;
}
.login-btn {
  margin-top: 20px;
  width:485px;
  height:44px;
  margin-left: 85px;
  font-size: 14px;
  background: #4978D6;
}
.callme-backhome {
  margin: 0 auto;
  margin-top: 16px;
  width:165px;
  height:36px;
  line-height: 36px;
  background:rgba(74,120,214,1);
  border-radius:4px;
  color: #fff;
  cursor: pointer;
}
.callme-secces {
   font-size:18px;
   color:rgba(40,40,40,1);
   margin-top: 21px;
}
.callme-take {
  margin-top: 16px;
  color:rgba(152,152,152,1);
  font-size:14px;
}
.callme-avatar {
   margin: 0 auto;
   display: block;
   width: 88px;
   height: 88px;

}
</style>
